type BillingTranslation = {
  title: string;
  description: string;
  company_information: string;
  company_information_description: string;
  company_name: string;
  company_name_placeholder: string;
  tax_id: string;
  tax_id_placeholder: string;
  company_email: string;
  company_email_placeholder: string;
  company_address: string;
  address_line_1: string;
  address_line_1_placeholder: string;
  address_line_2: string;
  address_line_2_placeholder: string;
  city: string;
  city_placeholder: string;
  state_province: string;
  state_province_placeholder: string;
  postal_code: string;
  postal_code_placeholder: string;
  country: string;
  country_placeholder: string;
  search_country: string;
  no_country_found: string;
  update_company: string;
  subscription_plans: string;
  subscription_plans_description: string;
  monthly: string;
  yearly: string;
  year: string;
  month: string;
  save_17: string;
  most_popular: string;
  get_started: string;
  subscribe: string;
  subscribe_now: string;
  upgrade: string;
  downgrade: string;
  subscription_details: string;
  subscription_details_description: string;
  status: string;
  status_active: string;
  status_canceled: string;
  status_past_due: string;
  status_trialing: string;
  status_incomplete: string;
  cancel_scheduled: string;
  feature_banks_2: string;
  feature_unlimited_history: string;
  feature_cash_flow: string;
  feature_auto_transactions: string;
  feature_ai_categories: string;
  feature_analytics: string;
  feature_financial_assistant: string;
  feature_users_1: string;
  feature_banks_5: string;
  feature_users_5: string;
  feature_team_permissions: string;
  feature_advanced_reports: string;
  feature_priority_support: string;
  feature_everything_in_essential: string;
  feature_unlimited_banks: string;
  feature_unlimited_users: string;
  feature_custom_integrations: string;
  feature_api_access: string;
  feature_account_manager: string;
  feature_support_24_7: string;
  feature_custom_sla: string;
  billing_cycle: string;
  renews_on: string;
  cancels_on: string;
  amount: string;
  manage_subscription: string;
  payment_failed: string;
  payment_failed_description: string;
  update_payment_method: string;
  stripe_secure: string;
  subscription_plan: string;
  subscription_plan_description: string;
  pro_plan: string;
  current_plan: string;
  per_month: string;
  next_billing_date: string;
  change_plan: string;
  cancel_subscription: string;
  payment_method: string;
  payment_method_description: string;
  visa_ending_in: string;
  expires: string;
  edit: string;
  add_payment_method: string;
  billing_history: string;
  billing_history_description: string;
  paid: string;
  download: string;
};

export const billingTranslations: Record<string, BillingTranslation> = {
  da: {
    title: "Fakturering",
    description: "Administrer dit abonnement og betalingsinformation",
    company_information: "Virksomhedsinformation",
    company_information_description: "Administrer dine virksomhedsoplysninger",
    company_name: "Virksomhedsnavn",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "CVR-nummer",
    tax_id_placeholder: "DK12345678",
    company_email: "Virksomheds-e-mail",
    company_email_placeholder: "virksomhed@eksempel.dk",
    company_address: "Virksomhedsadresse",
    address_line_1: "Adresselinje 1",
    address_line_1_placeholder: "Gadeadresse",
    address_line_2: "Adresselinje 2",
    address_line_2_placeholder: "Lejlighed, suite osv. (valgfrit)",
    city: "By",
    city_placeholder: "By",
    state_province: "Region",
    state_province_placeholder: "Region",
    postal_code: "Postnummer",
    postal_code_placeholder: "Postnummer",
    country: "Land",
    country_placeholder: "Vælg land",
    search_country: "Søg land...",
    no_country_found: "Intet land fundet.",
    update_company: "Opdater Virksomhed",
    subscription_plans: "Abonnementsplaner",
    subscription_plans_description: "Vælg den plan, der passer til dine behov",
    monthly: "Månedlig",
    yearly: "Årlig",
    year: "år",
    month: "måned",
    save_17: "Spar 17%",
    most_popular: "Mest populær",
    get_started: "Kom i gang",
    subscribe: "Kom i gang",
    subscribe_now: "Tilmeld nu",
    upgrade: "Opgrader",
    downgrade: "Nedgrader",
    subscription_details: "Abonnementsdetaljer",
    subscription_details_description: "Administrer dit aktive abonnement",
    status: "Status",
    status_active: "Aktiv",
    status_canceled: "Annulleret",
    status_past_due: "Forfalden",
    status_trialing: "Prøveperiode",
    status_incomplete: "Ufuldstændig",
    cancel_scheduled: "Planlagt opsigelse",
    feature_banks_2: "Op til 2 tilknyttede banker",
    feature_unlimited_history: "Ubegrænset historik",
    feature_cash_flow: "Cash flow i realtid",
    feature_auto_transactions: "Automatiske transaktioner",
    feature_ai_categories: "AI-drevne kategorier",
    feature_analytics: "Analyser",
    feature_financial_assistant: "Finansiel assistent",
    feature_users_1: "1 bruger",
    feature_banks_5: "Op til 5 tilknyttede banker",
    feature_users_5: "Op til 5 brugere",
    feature_team_permissions: "Teamtilladelser",
    feature_advanced_reports: "Avancerede rapporter",
    feature_priority_support: "Prioriteret support",
    feature_everything_in_essential: "Alt i Essential",
    feature_unlimited_banks: "Ubegrænsede banker",
    feature_unlimited_users: "Ubegrænsede brugere",
    feature_custom_integrations: "Tilpassede integrationer",
    feature_api_access: "API-adgang",
    feature_account_manager: "Dedikeret account manager",
    feature_support_24_7: "24/7 prioriteret support",
    feature_custom_sla: "Tilpasset SLA",
    billing_cycle: "Faktureringscyklus",
    renews_on: "Fornyes den",
    cancels_on: "Opsiges den",
    amount: "Beløb",
    manage_subscription: "Administrer abonnement",
    payment_failed: "Betaling mislykkedes",
    payment_failed_description: "Din seneste betaling mislykkedes. Opdater din betalingsmetode for at undgå afbrydelse af tjenesten.",
    update_payment_method: "Opdater betalingsmetode",
    stripe_secure: "Betalinger behandles sikkert af Stripe",
    subscription_plan: "Abonnementsplan",
    subscription_plan_description: "Administrer dit MoneyLights-abonnement",
    pro_plan: "Pro-Plan",
    current_plan: "Nuværende Plan",
    per_month: "/måned",
    next_billing_date: "Næste Faktureringsdato",
    change_plan: "Skift Plan",
    cancel_subscription: "Opsig Abonnement",
    payment_method: "Betalingsmetode",
    payment_method_description: "Administrer dine betalingsmetoder",
    visa_ending_in: "Visa slutter med",
    expires: "Udløber",
    edit: "Rediger",
    add_payment_method: "+ Tilføj Betalingsmetode",
    billing_history: "Faktureringshistorik",
    billing_history_description: "Se dine tidligere fakturaer",
    paid: "Betalt",
    download: "Download",
  },
  de: {
    title: "Abrechnung",
    description: "Verwalten Sie Ihr Abonnement und Zahlungsinformationen",
    company_information: "Unternehmensinformationen",
    company_information_description: "Verwalten Sie Ihre Unternehmensdetails",
    company_name: "Firmenname",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "Steuernummer",
    tax_id_placeholder: "DE123456789",
    company_email: "Unternehmens-E-Mail",
    company_email_placeholder: "unternehmen@beispiel.de",
    company_address: "Unternehmensadresse",
    address_line_1: "Adresszeile 1",
    address_line_1_placeholder: "Straßenadresse",
    address_line_2: "Adresszeile 2",
    address_line_2_placeholder: "Wohnung, Suite usw. (optional)",
    city: "Stadt",
    city_placeholder: "Stadt",
    state_province: "Bundesland",
    state_province_placeholder: "Bundesland",
    postal_code: "Postleitzahl",
    postal_code_placeholder: "Postleitzahl",
    country: "Land",
    country_placeholder: "Land auswählen",
    search_country: "Land suchen...",
    no_country_found: "Kein Land gefunden.",
    update_company: "Unternehmen aktualisieren",
    subscription_plans: "Abonnementpläne",
    subscription_plans_description: "Wählen Sie den Plan, der zu Ihnen passt",
    monthly: "Monatlich",
    yearly: "Jährlich",
    year: "Jahr",
    month: "Monat",
    save_17: "17% sparen",
    most_popular: "Beliebteste",
    get_started: "Loslegen",
    subscribe: "Loslegen",
    subscribe_now: "Jetzt abonnieren",
    upgrade: "Upgrade",
    downgrade: "Downgrade",
    subscription_details: "Abonnementdetails",
    subscription_details_description: "Verwalten Sie Ihr aktives Abonnement",
    status: "Status",
    status_active: "Aktiv",
    status_canceled: "Gekündigt",
    status_past_due: "Überfällig",
    status_trialing: "Testphase",
    status_incomplete: "Unvollständig",
    cancel_scheduled: "Kündigung geplant",
    feature_banks_2: "Bis zu 2 verbundene Banken",
    feature_unlimited_history: "Unbegrenzter Verlauf",
    feature_cash_flow: "Echtzeit-Cashflow",
    feature_auto_transactions: "Automatische Transaktionen",
    feature_ai_categories: "KI-gestützte Kategorien",
    feature_analytics: "Analysen",
    feature_financial_assistant: "Finanzassistent",
    feature_users_1: "1 Benutzer",
    feature_banks_5: "Bis zu 5 verbundene Banken",
    feature_users_5: "Bis zu 5 Benutzer",
    feature_team_permissions: "Team-Berechtigungen",
    feature_advanced_reports: "Erweiterte Berichte",
    feature_priority_support: "Priorisierter Support",
    feature_everything_in_essential: "Alles aus Essential",
    feature_unlimited_banks: "Unbegrenzte Banken",
    feature_unlimited_users: "Unbegrenzte Benutzer",
    feature_custom_integrations: "Individuelle Integrationen",
    feature_api_access: "API-Zugriff",
    feature_account_manager: "Dedizierter Account Manager",
    feature_support_24_7: "24/7 priorisierter Support",
    feature_custom_sla: "Individuelle SLA",
    billing_cycle: "Abrechnungszyklus",
    renews_on: "Verlängert am",
    cancels_on: "Kündigt am",
    amount: "Betrag",
    manage_subscription: "Abonnement verwalten",
    payment_failed: "Zahlung fehlgeschlagen",
    payment_failed_description: "Ihre letzte Zahlung ist fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsmethode.",
    update_payment_method: "Zahlungsmethode aktualisieren",
    stripe_secure: "Zahlungen werden sicher von Stripe verarbeitet",
    subscription_plan: "Abonnementplan",
    subscription_plan_description: "Verwalten Sie Ihr MoneyLights-Abonnement",
    pro_plan: "Pro-Plan",
    current_plan: "Aktueller Plan",
    per_month: "/Monat",
    next_billing_date: "Nächstes Abrechnungsdatum",
    change_plan: "Plan ändern",
    cancel_subscription: "Abonnement kündigen",
    payment_method: "Zahlungsmethode",
    payment_method_description: "Verwalten Sie Ihre Zahlungsmethoden",
    visa_ending_in: "Visa endend auf",
    expires: "Läuft ab",
    edit: "Bearbeiten",
    add_payment_method: "+ Zahlungsmethode hinzufügen",
    billing_history: "Abrechnungsverlauf",
    billing_history_description: "Frühere Rechnungen anzeigen",
    paid: "Bezahlt",
    download: "Herunterladen",
  },
  en: {
    title: "Billing",
    description: "Manage your subscription, payment methods, and billing information",
    company_information: "Company Information",
    company_information_description: "Manage your company details",
    company_name: "Company Name",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "Tax ID",
    tax_id_placeholder: "PT123456789",
    company_email: "Company Email",
    company_email_placeholder: "company@example.com",
    company_address: "Company Address",
    address_line_1: "Address Line 1",
    address_line_1_placeholder: "Street Address",
    address_line_2: "Address Line 2",
    address_line_2_placeholder: "Apartment, suite, etc. (optional)",
    city: "City",
    city_placeholder: "City",
    state_province: "State / Province",
    state_province_placeholder: "State or Province",
    postal_code: "Postal Code",
    postal_code_placeholder: "Postal code",
    country: "Country",
    country_placeholder: "Select country",
    search_country: "Search country...",
    no_country_found: "No country found.",
    update_company: "Update Company",
    subscription_plans: "Subscription Plans",
    subscription_plans_description: "Choose the plan that fits your needs",
    monthly: "Monthly",
    yearly: "Yearly",
    year: "year",
    month: "month",
    save_17: "Save 17%",
    most_popular: "Most Popular",
    get_started: "Get Started",
    subscribe: "Subscribe",
    subscribe_now: "Subscribe now",
    upgrade: "Upgrade",
    downgrade: "Downgrade",
    subscription_details: "Subscription Details",
    subscription_details_description: "Manage your active subscription",
    status: "Status",
    status_active: "Active",
    status_canceled: "Canceled",
    status_past_due: "Past Due",
    status_trialing: "Trial",
    status_incomplete: "Incomplete",
    cancel_scheduled: "Cancellation scheduled",
    feature_banks_2: "Up to 2 connected banks",
    feature_unlimited_history: "Unlimited history",
    feature_cash_flow: "Real-time Cash Flow",
    feature_auto_transactions: "Automatic transactions",
    feature_ai_categories: "AI-powered categories",
    feature_analytics: "Analytics",
    feature_financial_assistant: "Financial Assistant",
    feature_users_1: "1 user",
    feature_banks_5: "Up to 5 connected banks",
    feature_users_5: "Up to 5 users",
    feature_team_permissions: "Team permissions",
    feature_advanced_reports: "Advanced reports",
    feature_priority_support: "Priority support",
    feature_everything_in_essential: "Everything in Essential",
    feature_unlimited_banks: "Unlimited banks",
    feature_unlimited_users: "Unlimited users",
    feature_custom_integrations: "Custom integrations",
    feature_api_access: "API access",
    feature_account_manager: "Dedicated account manager",
    feature_support_24_7: "24/7 priority support",
    feature_custom_sla: "Custom SLA",
    billing_cycle: "Billing Cycle",
    renews_on: "Renews On",
    cancels_on: "Cancels On",
    amount: "Amount",
    manage_subscription: "Manage Subscription",
    payment_failed: "Payment Failed",
    payment_failed_description: "Your recent payment failed. Please update your payment method to avoid service interruption.",
    update_payment_method: "Update Payment Method",
    stripe_secure: "Payments are securely processed by Stripe",
    subscription_plan: "Subscription Plan",
    subscription_plan_description: "Manage your MoneyLights subscription",
    pro_plan: "Pro Plan",
    current_plan: "Current Plan",
    per_month: "/month",
    next_billing_date: "Next Billing Date",
    change_plan: "Change Plan",
    cancel_subscription: "Cancel Subscription",
    payment_method: "Payment Method",
    payment_method_description: "Manage your payment methods",
    visa_ending_in: "Visa ending in",
    expires: "Expires",
    edit: "Edit",
    add_payment_method: "+ Add Payment Method",
    billing_history: "Billing History",
    billing_history_description: "View your previous invoices",
    paid: "Paid",
    download: "Download",
  },
  es: {
    title: "Facturación",
    description: "Administrar tu suscripción, métodos de pago e información de facturación",
    company_information: "Información de la Empresa",
    company_information_description: "Administrar los detalles de tu empresa",
    company_name: "Nombre de la Empresa",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "NIF",
    tax_id_placeholder: "PT123456789",
    company_email: "Email de la Empresa",
    company_email_placeholder: "empresa@exemplo.com",
    company_address: "Dirección de la Empresa",
    address_line_1: "Línea de Dirección 1",
    address_line_1_placeholder: "Dirección de la calle",
    address_line_2: "Línea de Dirección 2",
    address_line_2_placeholder: "Apartamento, suite, etc. (opcional)",
    city: "Ciudad",
    city_placeholder: "Ciudad",
    state_province: "Estado / Provincia",
    state_province_placeholder: "Estado o Provincia",
    postal_code: "Código Postal",
    postal_code_placeholder: "Código postal",
    country: "País",
    country_placeholder: "Seleccionar país",
    search_country: "Buscar país...",
    no_country_found: "País no encontrado.",
    update_company: "Actualizar Empresa",
    subscription_plans: "Planes de Suscripción",
    subscription_plans_description: "Elige el plan que se adapte a tus necesidades",
    monthly: "Mensual",
    yearly: "Anual",
    year: "año",
    month: "mes",
    save_17: "Ahorra 17%",
    most_popular: "Más Popular",
    get_started: "Comenzar",
    subscribe: "Comenzar",
    subscribe_now: "Suscribirse ahora",
    upgrade: "Mejorar",
    downgrade: "Reducir",
    subscription_details: "Detalles de Suscripción",
    subscription_details_description: "Administrar tu suscripción activa",
    status: "Estado",
    status_active: "Activo",
    status_canceled: "Cancelado",
    status_past_due: "Pago Vencido",
    status_trialing: "Período de Prueba",
    status_incomplete: "Incompleto",
    cancel_scheduled: "Cancelación programada",
    feature_banks_2: "Hasta 2 bancos conectados",
    feature_unlimited_history: "Historial ilimitado",
    feature_cash_flow: "Flujo de caja en tiempo real",
    feature_auto_transactions: "Transacciones automáticas",
    feature_ai_categories: "Categorías con IA",
    feature_analytics: "Analíticas",
    feature_financial_assistant: "Asistente financiero",
    feature_users_1: "1 usuario",
    feature_banks_5: "Hasta 5 bancos conectados",
    feature_users_5: "Hasta 5 usuarios",
    feature_team_permissions: "Permisos de equipo",
    feature_advanced_reports: "Informes avanzados",
    feature_priority_support: "Soporte prioritario",
    feature_everything_in_essential: "Todo en Essential",
    feature_unlimited_banks: "Bancos ilimitados",
    feature_unlimited_users: "Usuarios ilimitados",
    feature_custom_integrations: "Integraciones personalizadas",
    feature_api_access: "Acceso a la API",
    feature_account_manager: "Gestor de cuenta dedicado",
    feature_support_24_7: "Soporte prioritario 24/7",
    feature_custom_sla: "SLA personalizado",
    billing_cycle: "Ciclo de Facturación",
    renews_on: "Renueva el",
    cancels_on: "Cancela el",
    amount: "Monto",
    manage_subscription: "Administrar Suscripción",
    payment_failed: "Pago Fallido",
    payment_failed_description: "Tu pago reciente falló. Por favor actualiza tu método de pago para evitar la interrupción del servicio.",
    update_payment_method: "Actualizar Método de Pago",
    stripe_secure: "Los pagos son procesados de forma segura por Stripe",
    subscription_plan: "Plan de Suscripción",
    subscription_plan_description: "Administrar tu suscripción MoneyLights",
    pro_plan: "Plan Pro",
    current_plan: "Plan Actual",
    per_month: "/mes",
    next_billing_date: "Próxima fecha de facturación",
    change_plan: "Cambiar Plan",
    cancel_subscription: "Cancelar Suscripción",
    payment_method: "Método de Pago",
    payment_method_description: "Administrar tus métodos de pago",
    visa_ending_in: "Visa terminado en",
    expires: "Expira",
    edit: "Editar",
    add_payment_method: "+ Agregar Método de Pago",
    billing_history: "Historial de Facturación",
    billing_history_description: "Ver tus facturas anteriores",
    paid: "Pagado",
    download: "Descargar",
  },
  et: {
    title: "Arveldus",
    description: "Haldage oma tellimust, maksemeetodeid ja arveldusinformatsiooni",
    company_information: "Ettevõtte informatsioon",
    company_information_description: "Haldage oma ettevõtte üksikasju",
    company_name: "Ettevõtte nimi",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "Maksukohus",
    tax_id_placeholder: "PT123456789",
    company_email: "Ettevõtte e-post",
    company_email_placeholder: "company@example.com",
    company_address: "Ettevõtte aadress",
    address_line_1: "Aadressi rida 1",
    address_line_1_placeholder: "Tänav",
    address_line_2: "Aadressi rida 2",
    address_line_2_placeholder: "Apartament, suite jne. (valikuline)",
    city: "Linn",
    city_placeholder: "Linn",
    state_province: "Riik / Maakond",
    state_province_placeholder: "Riik või maakond",
    postal_code: "Postiindeks",
    postal_code_placeholder: "Postiindeks",
    country: "Riik",
    country_placeholder: "Vali riik",
    search_country: "Otsi riiki...",
    no_country_found: "Riiki ei leitud.",
    update_company: "Uuenda ettevõtte",
    subscription_plans: "Tellimuse plaanid",
    subscription_plans_description: "Valige sobiv plaan",
    monthly: "Kuine",
    yearly: "Aastane",
    year: "aasta",
    month: "kuu",
    save_17: "Säästa 17%",
    most_popular: "Populaarseim",
    get_started: "Alusta",
    subscribe: "Alusta",
    subscribe_now: "Telli kohe",
    upgrade: "Uuenda",
    downgrade: "Vähenda",
    subscription_details: "Tellimuse üksikasjad",
    subscription_details_description: "Halda aktiivset tellimust",
    status: "Staatus",
    status_active: "Aktiivne",
    status_canceled: "Tühistatud",
    status_past_due: "Tähtaja ületanud",
    status_trialing: "Prooviperiood",
    status_incomplete: "Mittetäielik",
    cancel_scheduled: "Tühistamine ajastatud",
    feature_banks_2: "Kuni 2 ühendatud panka",
    feature_unlimited_history: "Piiramatu ajalugu",
    feature_cash_flow: "Reaalajas rahavoog",
    feature_auto_transactions: "Automaatsed tehingud",
    feature_ai_categories: "Tehisintellekti kategooriad",
    feature_analytics: "Analüütika",
    feature_financial_assistant: "Finantsassistent",
    feature_users_1: "1 kasutaja",
    feature_banks_5: "Kuni 5 ühendatud panka",
    feature_users_5: "Kuni 5 kasutajat",
    feature_team_permissions: "Tiimi õigused",
    feature_advanced_reports: "Täiustatud aruanded",
    feature_priority_support: "Prioriteetne tugi",
    feature_everything_in_essential: "Kõik Essentialis",
    feature_unlimited_banks: "Piiramatu hulk panku",
    feature_unlimited_users: "Piiramatu hulk kasutajaid",
    feature_custom_integrations: "Kohandatud integratsioonid",
    feature_api_access: "API-juurdepääs",
    feature_account_manager: "Pühendatud kontohaldur",
    feature_support_24_7: "24/7 prioriteetne tugi",
    feature_custom_sla: "Kohandatud SLA",
    billing_cycle: "Arveldustsükkel",
    renews_on: "Uueneb",
    cancels_on: "Tühistub",
    amount: "Summa",
    manage_subscription: "Halda tellimust",
    payment_failed: "Makse ebaõnnestus",
    payment_failed_description: "Teie viimane makse ebaõnnestus. Värskendage makseviisi.",
    update_payment_method: "Värskenda makseviisi",
    stripe_secure: "Maksed töödeldakse turvaliselt Stripe'i poolt",
    subscription_plan: "Tellimuse plaan",
    subscription_plan_description: "Haldage oma MoneyLights tellimust",
    pro_plan: "Pro plaan",
    current_plan: "Praegune plaan",
    per_month: "/kuu",
    next_billing_date: "Järgmine arvelduspäev",
    change_plan: "Muuda plaani",
    cancel_subscription: "Tühista tellimus",
    payment_method: "Maksemeetod",
    payment_method_description: "Haldage oma maksemeetodeid",
    visa_ending_in: "Visa lõpeb",
    expires: "Aegub",
    edit: "Muuda",
    add_payment_method: "+ Lisa maksemeetod",
    billing_history: "Arvelduste ajalugu",
    billing_history_description: "Vaadake oma eelmisi arveldusi",
    paid: "Makstud",
    download: "Laadi alla",
  },
  fi: {
    title: "Laskutus",
    description: "Hallitse tilaustasi ja maksutietoja",
    company_information: "Yritystiedot",
    company_information_description: "Hallitse yrityksesi tietoja",
    company_name: "Yrityksen Nimi",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "Y-tunnus",
    tax_id_placeholder: "FI12345678",
    company_email: "Yrityksen Sähköposti",
    company_email_placeholder: "yritys@esimerkki.fi",
    company_address: "Yrityksen Osoite",
    address_line_1: "Osoiterivi 1",
    address_line_1_placeholder: "Katuosoite",
    address_line_2: "Osoiterivi 2",
    address_line_2_placeholder: "Asunto, sviitti jne. (valinnainen)",
    city: "Kaupunki",
    city_placeholder: "Kaupunki",
    state_province: "Maakunta",
    state_province_placeholder: "Maakunta",
    postal_code: "Postinumero",
    postal_code_placeholder: "Postinumero",
    country: "Maa",
    country_placeholder: "Valitse maa",
    search_country: "Hae maata...",
    no_country_found: "Maata ei löytynyt.",
    update_company: "Päivitä Yritys",
    subscription_plans: "Abonnementsplannen",
    subscription_plans_description: "Kies het plan dat bij uw behoeften past",
    monthly: "Maandelijks",
    yearly: "Jaarlijks",
    year: "jaar",
    month: "maand",
    save_17: "Bespaar 17%",
    most_popular: "Meest populair",
    get_started: "Aan de slag",
    subscribe: "Aan de slag",
    subscribe_now: "Nu abonneren",
    upgrade: "Upgraden",
    downgrade: "Downgraden",
    subscription_details: "Abonnementsdetails",
    subscription_details_description: "Beheer uw actieve abonnement",
    status: "Status",
    status_active: "Actief",
    status_canceled: "Geannuleerd",
    status_past_due: "Achterstallig",
    status_trialing: "Proefperiode",
    status_incomplete: "Onvolledig",
    cancel_scheduled: "Geplande annulering",
    feature_banks_2: "Tot 2 gekoppelde banken",
    feature_unlimited_history: "Onbeperkte geschiedenis",
    feature_cash_flow: "Realtime cashflow",
    feature_auto_transactions: "Automatische transacties",
    feature_ai_categories: "AI-categorieën",
    feature_analytics: "Analyses",
    feature_financial_assistant: "Financiële assistent",
    feature_users_1: "1 gebruiker",
    feature_banks_5: "Tot 5 gekoppelde banken",
    feature_users_5: "Tot 5 gebruikers",
    feature_team_permissions: "Teamrechten",
    feature_advanced_reports: "Geavanceerde rapporten",
    feature_priority_support: "Prioriteitsupport",
    feature_everything_in_essential: "Alles in Essential",
    feature_unlimited_banks: "Onbeperkte banken",
    feature_unlimited_users: "Onbeperkte gebruikers",
    feature_custom_integrations: "Aangepaste integraties",
    feature_api_access: "API-toegang",
    feature_account_manager: "Dedicated accountmanager",
    feature_support_24_7: "24/7 prioriteitsupport",
    feature_custom_sla: "Maatwerk SLA",
    billing_cycle: "Factureringscyclus",
    renews_on: "Vernieuwt op",
    cancels_on: "Annuleert op",
    amount: "Bedrag",
    manage_subscription: "Abonnement beheren",
    payment_failed: "Betaling mislukt",
    payment_failed_description: "Uw recente betaling is mislukt. Werk uw betaalmethode bij om onderbreking van de service te voorkomen.",
    update_payment_method: "Betaalmethode bijwerken",
    stripe_secure: "Betalingen worden veilig verwerkt door Stripe",
    subscription_plan: "Tilaussuunnitelma",
    subscription_plan_description: "Hallitse MoneyLights-tilaustasi",
    pro_plan: "Pro-Suunnitelma",
    current_plan: "Nykyinen Suunnitelma",
    per_month: "/kuukausi",
    next_billing_date: "Seuraava Laskutuspäivä",
    change_plan: "Vaihda Suunnitelma",
    cancel_subscription: "Peru Tilaus",
    payment_method: "Maksutapa",
    payment_method_description: "Hallitse maksutapojasi",
    visa_ending_in: "Visa päättyy",
    expires: "Vanhenee",
    edit: "Muokkaa",
    add_payment_method: "+ Lisää Maksutapa",
    billing_history: "Laskutushistoria",
    billing_history_description: "Tarkastele aiempia laskujasi",
    paid: "Maksettu",
    download: "Lataa",
  },
  fr: {
    title: "Facturation",
    description: "Gérer votre abonnement et informations de paiement",
    company_information: "Informations sur l'Entreprise",
    company_information_description: "Gérer les détails de votre entreprise",
    company_name: "Nom de l'Entreprise",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "Numéro TVA",
    tax_id_placeholder: "FR123456789",
    company_email: "E-mail de l'Entreprise",
    company_email_placeholder: "entreprise@exemple.fr",
    company_address: "Adresse de l'Entreprise",
    address_line_1: "Ligne d'Adresse 1",
    address_line_1_placeholder: "Adresse de la rue",
    address_line_2: "Ligne d'Adresse 2",
    address_line_2_placeholder: "Appartement, suite, etc. (facultatif)",
    city: "Ville",
    city_placeholder: "Ville",
    state_province: "État / Province",
    state_province_placeholder: "État ou Province",
    postal_code: "Code Postal",
    postal_code_placeholder: "Code postal",
    country: "Pays",
    country_placeholder: "Sélectionner le pays",
    search_country: "Rechercher un pays...",
    no_country_found: "Aucun pays trouvé.",
    update_company: "Mettre à jour l'Entreprise",
    subscription_plans: "Plans d'Abonnement",
    subscription_plans_description: "Choisissez le plan qui vous convient",
    monthly: "Mensuel",
    yearly: "Annuel",
    year: "an",
    month: "mois",
    save_17: "Économisez 17%",
    most_popular: "Le Plus Populaire",
    get_started: "Commencer",
    subscribe: "Commencer",
    subscribe_now: "S’abonner maintenant",
    upgrade: "Mettre à niveau",
    downgrade: "Rétrograder",
    subscription_details: "Détails de l'Abonnement",
    subscription_details_description: "Gérer votre abonnement actif",
    status: "Statut",
    status_active: "Actif",
    status_canceled: "Annulé",
    status_past_due: "En retard",
    status_trialing: "Période d'essai",
    status_incomplete: "Incomplet",
    cancel_scheduled: "Annulation programmée",
    feature_banks_2: "Jusqu’à 2 banques connectées",
    feature_unlimited_history: "Historique illimité",
    feature_cash_flow: "Flux de trésorerie en temps réel",
    feature_auto_transactions: "Transactions automatiques",
    feature_ai_categories: "Catégories IA",
    feature_analytics: "Analyses",
    feature_financial_assistant: "Assistant financier",
    feature_users_1: "1 utilisateur",
    feature_banks_5: "Jusqu’à 5 banques connectées",
    feature_users_5: "Jusqu’à 5 utilisateurs",
    feature_team_permissions: "Permissions d’équipe",
    feature_advanced_reports: "Rapports avancés",
    feature_priority_support: "Support prioritaire",
    feature_everything_in_essential: "Tout dans Essential",
    feature_unlimited_banks: "Banques illimitées",
    feature_unlimited_users: "Utilisateurs illimités",
    feature_custom_integrations: "Intégrations personnalisées",
    feature_api_access: "Accès API",
    feature_account_manager: "Gestionnaire de compte dédié",
    feature_support_24_7: "Support prioritaire 24/7",
    feature_custom_sla: "SLA personnalisé",
    billing_cycle: "Cycle de Facturation",
    renews_on: "Renouvelle le",
    cancels_on: "Annule le",
    amount: "Montant",
    manage_subscription: "Gérer l'Abonnement",
    payment_failed: "Paiement Échoué",
    payment_failed_description: "Votre paiement récent a échoué. Veuillez mettre à jour votre méthode de paiement.",
    update_payment_method: "Mettre à jour le Moyen de Paiement",
    stripe_secure: "Les paiements sont traités en toute sécurité par Stripe",
    subscription_plan: "Plan d'Abonnement",
    subscription_plan_description: "Gérer votre abonnement MoneyLights",
    pro_plan: "Plan Pro",
    current_plan: "Plan Actuel",
    per_month: "/mois",
    next_billing_date: "Prochaine Date de Facturation",
    change_plan: "Changer de Plan",
    cancel_subscription: "Annuler l'Abonnement",
    payment_method: "Méthode de Paiement",
    payment_method_description: "Gérer vos méthodes de paiement",
    visa_ending_in: "Visa se terminant par",
    expires: "Expire",
    edit: "Modifier",
    add_payment_method: "+ Ajouter une Méthode de Paiement",
    billing_history: "Historique de Facturation",
    billing_history_description: "Voir vos factures précédentes",
    paid: "Payé",
    download: "Télécharger",
  },
  it: {
    title: "Fatturazione",
    description: "Gestire abbonamento e informazioni di pagamento",
    company_information: "Informazioni Azienda",
    company_information_description: "Gestire i dettagli dell'azienda",
    company_name: "Nome Azienda",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "Partita IVA",
    tax_id_placeholder: "IT123456789",
    company_email: "Email Azienda",
    company_email_placeholder: "azienda@esempio.it",
    company_address: "Indirizzo Azienda",
    address_line_1: "Indirizzo Riga 1",
    address_line_1_placeholder: "Indirizzo via",
    address_line_2: "Indirizzo Riga 2",
    address_line_2_placeholder: "Appartamento, suite, ecc. (facoltativo)",
    city: "Città",
    city_placeholder: "Città",
    state_province: "Stato / Provincia",
    state_province_placeholder: "Stato o Provincia",
    postal_code: "Codice Postale",
    postal_code_placeholder: "Codice postale",
    country: "Paese",
    country_placeholder: "Seleziona paese",
    search_country: "Cerca paese...",
    no_country_found: "Nessun paese trovato.",
    update_company: "Aggiorna Azienda",
    subscription_plans: "Piani di Abbonamento",
    subscription_plans_description: "Scegli il piano adatto alle tue esigenze",
    monthly: "Mensile",
    yearly: "Annuale",
    year: "anno",
    month: "mese",
    save_17: "Risparmia 17%",
    most_popular: "Più Popolare",
    get_started: "Inizia",
    subscribe: "Inizia",
    subscribe_now: "Abbonati ora",
    upgrade: "Aggiorna",
    downgrade: "Declassa",
    subscription_details: "Dettagli Abbonamento",
    subscription_details_description: "Gestisci il tuo abbonamento attivo",
    status: "Stato",
    status_active: "Attivo",
    status_canceled: "Annullato",
    status_past_due: "Scaduto",
    status_trialing: "Prova",
    status_incomplete: "Incompleto",
    cancel_scheduled: "Annullamento programmato",
    feature_banks_2: "Fino a 2 banche collegate",
    feature_unlimited_history: "Storico illimitato",
    feature_cash_flow: "Cash flow in tempo reale",
    feature_auto_transactions: "Transazioni automatiche",
    feature_ai_categories: "Categorie IA",
    feature_analytics: "Analitiche",
    feature_financial_assistant: "Assistente finanziario",
    feature_users_1: "1 utente",
    feature_banks_5: "Fino a 5 banche collegate",
    feature_users_5: "Fino a 5 utenti",
    feature_team_permissions: "Permessi del team",
    feature_advanced_reports: "Report avanzati",
    feature_priority_support: "Supporto prioritario",
    feature_everything_in_essential: "Tutto in Essential",
    feature_unlimited_banks: "Banche illimitate",
    feature_unlimited_users: "Utenti illimitati",
    feature_custom_integrations: "Integrazioni personalizzate",
    feature_api_access: "Accesso API",
    feature_account_manager: "Account manager dedicato",
    feature_support_24_7: "Supporto prioritario 24/7",
    feature_custom_sla: "SLA personalizzato",
    billing_cycle: "Ciclo di Fatturazione",
    renews_on: "Rinnova il",
    cancels_on: "Annulla il",
    amount: "Importo",
    manage_subscription: "Gestisci Abbonamento",
    payment_failed: "Pagamento Fallito",
    payment_failed_description: "Il tuo ultimo pagamento è fallito. Aggiorna il metodo di pagamento.",
    update_payment_method: "Aggiorna Metodo di Pagamento",
    stripe_secure: "I pagamenti sono elaborati in modo sicuro da Stripe",
    subscription_plan: "Piano di Abbonamento",
    subscription_plan_description: "Gestire l'abbonamento MoneyLights",
    pro_plan: "Piano Pro",
    current_plan: "Piano Attuale",
    per_month: "/mese",
    next_billing_date: "Prossima Data di Fatturazione",
    change_plan: "Cambia Piano",
    cancel_subscription: "Annulla Abbonamento",
    payment_method: "Metodo di Pagamento",
    payment_method_description: "Gestire i metodi di pagamento",
    visa_ending_in: "Visa terminante con",
    expires: "Scade",
    edit: "Modifica",
    add_payment_method: "+ Aggiungi Metodo di Pagamento",
    billing_history: "Storico Fatturazione",
    billing_history_description: "Visualizza le fatture precedenti",
    paid: "Pagato",
    download: "Scarica",
  },
  nl: {
    title: "Facturering",
    description: "Beheer uw abonnement en betalingsinformatie",
    company_information: "Bedrijfsinformatie",
    company_information_description: "Beheer uw bedrijfsgegevens",
    company_name: "Bedrijfsnaam",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "BTW-nummer",
    tax_id_placeholder: "NL123456789B01",
    company_email: "Bedrijfs-e-mail",
    company_email_placeholder: "bedrijf@voorbeeld.nl",
    company_address: "Bedrijfsadres",
    address_line_1: "Adresregel 1",
    address_line_1_placeholder: "Straatnaam",
    address_line_2: "Adresregel 2",
    address_line_2_placeholder: "Appartement, suite, enz. (optioneel)",
    city: "Plaats",
    city_placeholder: "Plaats",
    state_province: "Provincie",
    state_province_placeholder: "Provincie",
    postal_code: "Postcode",
    postal_code_placeholder: "Postcode",
    country: "Land",
    country_placeholder: "Selecteer land",
    search_country: "Zoek land...",
    no_country_found: "Geen land gevonden.",
    update_company: "Bedrijf Bijwerken",
    subscription_plans: "Tilaussuunnitelmat",
    subscription_plans_description: "Valitse tarpeisiisi sopiva suunnitelma",
    monthly: "Kuukausittain",
    yearly: "Vuosittain",
    year: "vuosi",
    month: "kuukausi",
    save_17: "Säästä 17%",
    most_popular: "Suosituin",
    get_started: "Aloita",
    subscribe: "Aloita",
    subscribe_now: "Tilaa nyt",
    upgrade: "Päivitä",
    downgrade: "Alenna",
    subscription_details: "Tilauksen tiedot",
    subscription_details_description: "Hallitse aktiivista tilaustasi",
    status: "Tila",
    status_active: "Aktiivinen",
    status_canceled: "Peruttu",
    status_past_due: "Erääntynyt",
    status_trialing: "Kokeilu",
    status_incomplete: "Keskeneräinen",
    cancel_scheduled: "Peruutus ajastettu",
    feature_banks_2: "Enintään 2 liitettyä pankkia",
    feature_unlimited_history: "Rajoittamaton historia",
    feature_cash_flow: "Reaaliaikainen kassavirta",
    feature_auto_transactions: "Automaattiset tapahtumat",
    feature_ai_categories: "Tekoälykategoriat",
    feature_analytics: "Analytiikka",
    feature_financial_assistant: "Talousavustaja",
    feature_users_1: "1 käyttäjä",
    feature_banks_5: "Enintään 5 liitettyä pankkia",
    feature_users_5: "Enintään 5 käyttäjää",
    feature_team_permissions: "Tiimin käyttöoikeudet",
    feature_advanced_reports: "Edistyneet raportit",
    feature_priority_support: "Prioriteettituki",
    feature_everything_in_essential: "Kaikki Essentialissa",
    feature_unlimited_banks: "Rajoittamaton määrä pankkeja",
    feature_unlimited_users: "Rajoittamaton määrä käyttäjiä",
    feature_custom_integrations: "Räätälöidyt integraatiot",
    feature_api_access: "API-käyttö",
    feature_account_manager: "Oma asiakasvastaava",
    feature_support_24_7: "24/7 prioriteettituki",
    feature_custom_sla: "Räätälöity SLA",
    billing_cycle: "Laskutusjakso",
    renews_on: "Uusiutuu",
    cancels_on: "Peruutetaan",
    amount: "Summa",
    manage_subscription: "Hallitse tilausta",
    payment_failed: "Maksu epäonnistui",
    payment_failed_description: "Viimeisin maksusi epäonnistui. Päivitä maksutapasi välttääksesi palvelun keskeytymisen.",
    update_payment_method: "Päivitä maksutapa",
    stripe_secure: "Maksut käsitellään turvallisesti Stripen kautta",
    subscription_plan: "Abonnementsplan",
    subscription_plan_description: "Beheer uw MoneyLights-abonnement",
    pro_plan: "Pro Plan",
    current_plan: "Huidig Plan",
    per_month: "/maand",
    next_billing_date: "Volgende Factuurdatum",
    change_plan: "Plan Wijzigen",
    cancel_subscription: "Abonnement Annuleren",
    payment_method: "Betaalmethode",
    payment_method_description: "Beheer uw betaalmethoden",
    visa_ending_in: "Visa eindigend op",
    expires: "Verloopt",
    edit: "Bewerken",
    add_payment_method: "+ Betaalmethode Toevoegen",
    billing_history: "Factureringsgeschiedenis",
    billing_history_description: "Bekijk uw eerdere facturen",
    paid: "Betaald",
    download: "Downloaden",
  },
  pt: {
    title: "Faturação",
    description: "Gerir a sua subscrição, métodos de pagamento e informação de faturação",
    company_information: "Informação da Empresa",
    company_information_description: "Gerir os detalhes da sua empresa",
    company_name: "Nome da Empresa",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "NIF",
    tax_id_placeholder: "PT123456789",
    company_email: "Email da Empresa",
    company_email_placeholder: "empresa@exemplo.com",
    company_address: "Morada da Empresa",
    address_line_1: "Linha de Morada 1",
    address_line_1_placeholder: "Morada da rua",
    address_line_2: "Linha de Morada 2",
    address_line_2_placeholder: "Apartamento, suite, etc. (opcional)",
    city: "Cidade",
    city_placeholder: "Cidade",
    state_province: "Estado / Província",
    state_province_placeholder: "Estado ou Província",
    postal_code: "Código Postal",
    postal_code_placeholder: "Código postal",
    country: "País",
    country_placeholder: "Selecionar país",
    search_country: "Pesquisar país...",
    no_country_found: "Nenhum país encontrado.",
    update_company: "Atualizar Empresa",
    subscription_plans: "Planos de Subscrição",
    subscription_plans_description: "Escolha o plano que se adequa às suas necessidades",
    monthly: "Mensal",
    yearly: "Anual",
    year: "ano",
    month: "mês",
    save_17: "Poupe 17%",
    most_popular: "Mais Popular",
    get_started: "Começar",
    subscribe: "Subscrever",
    subscribe_now: "Subscrever já",
    upgrade: "Fazer Upgrade",
    downgrade: "Fazer Downgrade",
    subscription_details: "Detalhes da Subscrição",
    subscription_details_description: "Gerir a sua subscrição ativa",
    status: "Estado",
    status_active: "Ativo",
    status_canceled: "Cancelado",
    status_past_due: "Pagamento Atrasado",
    status_trialing: "Período de Teste",
    status_incomplete: "Incompleto",
    cancel_scheduled: "Cancelamento agendado",
    feature_banks_2: "Até 2 bancos ligados",
    feature_unlimited_history: "Histórico ilimitado",
    feature_cash_flow: "Fluxo de caixa em tempo real",
    feature_auto_transactions: "Transações automáticas",
    feature_ai_categories: "Categorias com IA",
    feature_analytics: "Análises",
    feature_financial_assistant: "Assistente financeiro",
    feature_users_1: "1 utilizador",
    feature_banks_5: "Até 5 bancos ligados",
    feature_users_5: "Até 5 utilizadores",
    feature_team_permissions: "Permissões de equipa",
    feature_advanced_reports: "Relatórios avançados",
    feature_priority_support: "Suporte prioritário",
    feature_everything_in_essential: "Tudo no Essential",
    feature_unlimited_banks: "Bancos ilimitados",
    feature_unlimited_users: "Utilizadores ilimitados",
    feature_custom_integrations: "Integrações personalizadas",
    feature_api_access: "Acesso à API",
    feature_account_manager: "Gestor de conta dedicado",
    feature_support_24_7: "Suporte prioritário 24/7",
    feature_custom_sla: "SLA personalizado",
    billing_cycle: "Ciclo de Faturação",
    renews_on: "Renova em",
    cancels_on: "Cancela em",
    amount: "Valor",
    manage_subscription: "Gerir Subscrição",
    payment_failed: "Pagamento Falhado",
    payment_failed_description: "O seu pagamento recente falhou. Por favor atualize o método de pagamento para evitar interrupção do serviço.",
    update_payment_method: "Atualizar Método de Pagamento",
    stripe_secure: "Os pagamentos são processados de forma segura pela Stripe",
    subscription_plan: "Plano de Subscrição",
    subscription_plan_description: "Gerir a sua subscrição MoneyLights",
    pro_plan: "Plano Pro",
    current_plan: "Plano Atual",
    per_month: "/mês",
    next_billing_date: "Próxima data de faturação",
    change_plan: "Mudar Plano",
    cancel_subscription: "Cancelar Subscrição",
    payment_method: "Método de Pagamento",
    payment_method_description: "Gerir os seus métodos de pagamento",
    visa_ending_in: "Visa terminado em",
    expires: "Expira",
    edit: "Editar",
    add_payment_method: "+ Adicionar Método de Pagamento",
    billing_history: "Histórico de Faturação",
    billing_history_description: "Ver as suas faturas anteriores",
    paid: "Pago",
    download: "Descarregar",
  },
  sv: {
    title: "Fakturering",
    description: "Hantera din prenumeration och betalningsinformation",
    company_information: "Företagsinformation",
    company_information_description: "Hantera dina företagsdetaljer",
    company_name: "Företagsnamn",
    company_name_placeholder: "Borlantrix OÜ",
    tax_id: "Organisationsnummer",
    tax_id_placeholder: "SE123456789001",
    company_email: "Företags-e-post",
    company_email_placeholder: "foretag@exempel.se",
    company_address: "Företagsadress",
    address_line_1: "Adressrad 1",
    address_line_1_placeholder: "Gatuadress",
    address_line_2: "Adressrad 2",
    address_line_2_placeholder: "Lägenhet, svit, etc. (valfritt)",
    city: "Stad",
    city_placeholder: "Stad",
    state_province: "Län",
    state_province_placeholder: "Län",
    postal_code: "Postnummer",
    postal_code_placeholder: "Postnummer",
    country: "Land",
    country_placeholder: "Välj land",
    search_country: "Sök land...",
    no_country_found: "Inget land hittades.",
    update_company: "Uppdatera Företag",
    subscription_plans: "Prenumerationsplaner",
    subscription_plans_description: "Välj planen som passar dina behov",
    monthly: "Månadsvis",
    yearly: "Årlig",
    year: "år",
    month: "månad",
    save_17: "Spara 17%",
    most_popular: "Mest populär",
    get_started: "Kom igång",
    subscribe: "Kom igång",
    subscribe_now: "Prenumerera nu",
    upgrade: "Uppgradera",
    downgrade: "Nedgradera",
    subscription_details: "Prenumerationsdetaljer",
    subscription_details_description: "Hantera din aktiva prenumeration",
    status: "Status",
    status_active: "Aktiv",
    status_canceled: "Avbruten",
    status_past_due: "Förfallen",
    status_trialing: "Provperiod",
    status_incomplete: "Ofullständig",
    cancel_scheduled: "Schemalagd uppsägning",
    feature_banks_2: "Upp till 2 anslutna banker",
    feature_unlimited_history: "Obegränsad historik",
    feature_cash_flow: "Kassaflöde i realtid",
    feature_auto_transactions: "Automatiska transaktioner",
    feature_ai_categories: "AI-kategorier",
    feature_analytics: "Analys",
    feature_financial_assistant: "Finansassistent",
    feature_users_1: "1 användare",
    feature_banks_5: "Upp till 5 anslutna banker",
    feature_users_5: "Upp till 5 användare",
    feature_team_permissions: "Teambehörigheter",
    feature_advanced_reports: "Avancerade rapporter",
    feature_priority_support: "Prioriterad support",
    feature_everything_in_essential: "Allt i Essential",
    feature_unlimited_banks: "Obegränsade banker",
    feature_unlimited_users: "Obegränsade användare",
    feature_custom_integrations: "Anpassade integrationer",
    feature_api_access: "API-åtkomst",
    feature_account_manager: "Dedikerad account manager",
    feature_support_24_7: "24/7 prioriterad support",
    feature_custom_sla: "Anpassad SLA",
    billing_cycle: "Faktureringscykel",
    renews_on: "Förnyas den",
    cancels_on: "Avslutas den",
    amount: "Belopp",
    manage_subscription: "Hantera prenumeration",
    payment_failed: "Betalning misslyckades",
    payment_failed_description: "Din senaste betalning misslyckades. Uppdatera din betalningsmetod för att undvika avbrott i tjänsten.",
    update_payment_method: "Uppdatera betalningsmetod",
    stripe_secure: "Betalningar behandlas säkert av Stripe",
    subscription_plan: "Prenumerationsplan",
    subscription_plan_description: "Hantera din MoneyLights-prenumeration",
    pro_plan: "Pro-Plan",
    current_plan: "Nuvarande Plan",
    per_month: "/månad",
    next_billing_date: "Nästa Faktureringsdatum",
    change_plan: "Ändra Plan",
    cancel_subscription: "Avsluta Prenumeration",
    payment_method: "Betalningsmetod",
    payment_method_description: "Hantera dina betalningsmetoder",
    visa_ending_in: "Visa slutar med",
    expires: "Går ut",
    edit: "Redigera",
    add_payment_method: "+ Lägg till Betalningsmetod",
    billing_history: "Faktureringshistorik",
    billing_history_description: "Visa dina tidigare fakturor",
    paid: "Betald",
    download: "Ladda ner",
  },
};
